export const CAMPAIGN_OBJECTIVES = [
  'awareness',
  'engagement',
  'response',
] as const;

export type CampaignObjective = (typeof CAMPAIGN_OBJECTIVES)[number];

export const CAMPAIGN_TYPES = [
  'preReleaseHype',
  'singleAlbumPlaylistPromotion',
  'artistDevelopment',
  'eventAmplification',
  'catalogReEngagement',
  'soundGrowthTrendAmplification',
  'fanGrowth',
  'd2cConversions',
] as const;

export type CampaignType = (typeof CAMPAIGN_TYPES)[number];

export const MEDIA_PLATFORMS = [
  'instagram',
  'tiktok',
  'spotify',
  'appleMusic',
  'youtube',
  'facebook',
] as const;

export type MediaPlatform = (typeof MEDIA_PLATFORMS)[number];

export const MEDIA_PLAN_GOAL = [
  'videoViews',
  'demandGen',
  'display',
  'performanceMax',
  'search',
  'shopping',
  'video',
] as const;

export type MediaPlanGoal = (typeof MEDIA_PLAN_GOAL)[number];

// @TODO WMG1-604 - Figure out the proper currency codes. They might come from
//                  somewhere else.
export const CURRENCY_CODES = [
  'USD',
  'EUR',
  'GBP',
  'CAD',
  'AUD',
  'JPY',
  'CHF',
  'NZD',
  'SEK',
  'NOK',
  'DKK',
  'PLN',
  'MXN',
  'BRL',
  'INR',
  'CNY',
  'KRW',
  'SGD',
  'HKD',
  'ZAR',
] as const;

export type CurrencyCode = (typeof CURRENCY_CODES)[number];

export const FREQUENCY_PERIODS = ['day', 'week'] as const;

export type FrequencyPeriod = (typeof FREQUENCY_PERIODS)[number];
